module.exports = __webpack_public_path__ + "static/media/Screen Shot 2560-11-26 at 18.44.59.bfb2d8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bcbk8/Screen Shot 2560-11-26 at 18.44.59.png
// module id = 114
// module chunks = 0